import React, { useState, useEffect } from 'react';
import { siteContent } from '../../data/content';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      const sections = siteContent.navigation.menu.map(item => item.id);
      const currentSection = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });

      if (currentSection) {
        setActiveSection(currentSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuClick = (href) => {
    setIsMenuOpen(false);

    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      {/* HEADER */}
      <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
        <div className="container">
          <div className="header__content">
            {/* Logo */}
            <div className="header__logo">
              <a href="#home" onClick={() => handleMenuClick('#home')}>
                {siteContent.navigation.logo}
              </a>
            </div>

            {/* Desktop Navigation */}
            <nav className="header__nav">
              <ul className="header__menu">
                {siteContent.navigation.menu.map((item, index) => (
                  <li key={index} className="header__menu-item">
                    <a
                      href={item.href}
                      className={`header__menu-link ${activeSection === item.id ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleMenuClick(item.href);
                      }}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Burger Button */}
            <button
              className={`header__mobile-toggle ${isMenuOpen ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE NAVIGATION – moved outside of <header> */}
      <nav className={`header__mobile-nav ${isMenuOpen ? 'active' : ''}`}>
        <ul className="header__mobile-menu">
          {siteContent.navigation.menu.map((item, index) => (
            <li key={index} className="header__mobile-menu-item">
              <a
                href={item.href}
                className={`header__mobile-menu-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleMenuClick(item.href);
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
          <li className="header__mobile-menu-item">
            <a href="#contact" className="btn btn-primary" onClick={() => handleMenuClick('#contact')}>
              Soutenir l'ONG
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
